export default "__VITE_ASSET__BHedNW4M__"